module.exports = __webpack_public_path__ + "media/images/iconInfoCircle--red-d4837307d1073d7759ef29b00d27d01e.png";